const ContractMain = () => import(/* webpackChunkName: "admin-module" */ './index');
const Contracts = () => import(/* webpackChunkName: "admin-module" */ './views/Contracts');
const Show = () => import(/* webpackChunkName: "admin-module" */ './views/Show');
const Create = () => import(/* webpackChunkName: "admin-module" */ './views/Create');
const CreateEmpty = () => import(/* webpackChunkName: "admin-module" */ './views/CreateEmpty');

export default [
    {
        path: 'contracts',
        components: { base: ContractMain },
        children: [
            {
                path: '',
                name: 'contracts',
                components: { contract: Contracts }
            },
            {
                path: ':contract_id/show',
                name: 'contracts.show',
                components: { contract: Show }
            },
            {
                path: ':booking_id/create',
                name: 'contracts.create',
                components: { contract: Create }
            },
            {
                path: 'create-empty',
                name: 'contracts.create.empty',
                components: { contract: CreateEmpty }
            }
        ]
    },
];
